
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-1b2e37b2\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./breadcrumb.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./breadcrumb.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1b2e37b2\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./breadcrumb.vue"),
  /* scopeId */
  "data-v-1b2e37b2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/breadcrumb.vue
// module id = 1301
// module chunks = 1